import * as React from 'react';
import { useLeapData } from '../../hooks/useLeapData';
import { useLeapState } from '../../hooks/useLeapState';

import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';

import Text from '../../components/controls/Text';
import DentalChart from '../../components/controls/dental/DentalChart';
import { DentalElements } from '../../components/controls/dental/dentalElements';
import SearchBox from '../../components/controls/SearchBox';
import MultiBox from '../../components/controls/MultiBox';
import { IComboBoxOption } from '@fluentui/react';
import BodyChart from '../../components/controls/body/BodyChart';
import { BodyElements } from '../../components/controls/body/bodyElements';

type Props = { state: any, controller: any, parentController: any }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const healthServiceID = useLeapData("healthServiceID", "prestazione", page, "healthService")
    const dentalElement = useLeapData("dentalElement", "elementi dentali", page)
    const rate = useLeapData("rate", "tariffa", page)
    const endDate = useLeapData("endDate", "data fine validità", page)
    const anatomicalElement = useLeapData("anatomicalElement", "elementi anatomici", page)

    const items: IComboBoxOption[] = DentalElements
    const selectedTeeth = page.item.values?.dentalElement !== undefined ? page.item.values.dentalElement?.value : dentalElement?.value !== null ? dentalElement?.value : [];

    const selectedPath = page.item.values?.anatomicalElement != null ? page.item.values.anatomicalElement?.value : [];

    const bodyItems: IComboBoxOption[] = BodyElements

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <SearchBox {...healthServiceID} parentController={props.parentController} className="ms-sm10" required />
                    </Row>
                    <Row>
                        <Text {...rate} className="ms-sm2" type="number" precision={{ integer: 9, decimal: 2, min: 0 }} required />
                        <Text {...endDate} className="ms-sm2" type="calendar" />
                    </Row>
                    <Row>
                        <MultiBox {...dentalElement} className="ms-sm10" options={items} required={props?.state?.item?.values?.medicalSpecialtyTypeId?.value !== '2'} hidden={props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '2' } selectedKey={selectedTeeth} />
                    </Row>
                    <Row>
                        <MultiBox {...anatomicalElement} className="ms-sm12" options={bodyItems} selectedKey={selectedPath} required={props?.state?.item?.values?.medicalSpecialtyTypeId?.value !== '1'} hidden={props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '1'} titleType="text" />
                    </Row>
                </Section>
                <Section title="elementi dentali" hidden={props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '2'}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}>
                        <Row>
                            <DentalChart {...dentalElement} selectionMode="multiple" value={selectedTeeth} required={props?.state?.item?.values?.medicalSpecialtyTypeId?.value !== '2'} />
                        </Row>
                    </div>
                </Section>
                <Section title="elementi anatomici" hidden={props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '1'}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}>
                        <Row>
                            <BodyChart {...anatomicalElement} parentController={props.parentController} isFemale={true} selectionMode="multiple" value={selectedTeeth} required={props?.state?.item?.values?.medicalSpecialtyTypeId?.value !== '1'} />
                        </Row>
                    </div>
                </Section>
            </Grid>
        </>
    );
}
